module.exports = __webpack_public_path__ + "static/media/3.bb320130.jpg";